import Modal from 'react-modal'

const GeneralModal = ({
  isOpen,
  onRequestClose,
  title,
  buttons = [],
  secondaryButtons = [],
  children,
  hideCancel,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={title}
      className="modal w-[600px]"
      overlayClassName="modal-overlay"
    >
      <div className="flex flex-col">
        <div className="p-6 bg-gray-light rounded-t flex items-center">
          <h2>{title}</h2>
        </div>
        <div className="flex-1 p-6 ">{children}</div>
        <div className="flex p-6 bg-gray-dark rounded-b">
          <div className="flex flex-fill">
            {secondaryButtons.map((button) => (
              <div key={button.text}>
                <button
                  className={button.className}
                  onClick={button.onClick}
                  disabled={button.disabled}
                >
                  {button.text}
                </button>
              </div>
            ))}
          </div>
          {!hideCancel && (
            <div>
              <button className="button hover:bg-deep" onClick={onRequestClose}>
                Cancel
              </button>
            </div>
          )}
          {buttons.map((button) => (
            <div key={button.text}>
              <button
                className={button.className}
                onClick={button.onClick}
                disabled={button.disabled}
              >
                {button.text}
              </button>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default GeneralModal
